<template>

  <Header
    :date="this.schedule.date"
    :changeDate="changeScheduleDate"
    :toggleModal="toggleModal"
    @scroll-to-today="scrollToToday()"
  />

  <Schedule
    ref="schedule"
    :date="this.schedule.date"
    :rooms="this.rooms"
    :bookings="this.bookings"
    :removeBooking="removeBooking"
    :toggleModal="toggleModal"
    :loading="this.schedule.loading"
    v-on:keyup.left="changeScheduleDate(`prev`)"
    v-on:keyup.right="changeScheduleDate(`next`)"
  />

  <Modal
    :modalActive="this.modal.active"
    :bookingData="this.modal.booking"
    :rooms="this.rooms"
    :toggleModal="toggleModal"
    :removeBooking="removeBooking"
    :getBookings="getBookings"
    :scheduleDate="this.schedule.date"
  />

</template>

<script>
import moment from 'moment'

import Header from './components/Header.vue'
import Schedule from './components/Schedule.vue'
import Modal from './components/Modal.vue'

export default {
  name: 'App',
  components: {
    Header,
    Schedule,
    Modal
  },
  methods: {

    changeScheduleDate(direction = `prev`) {
      if (direction === `next`) {
        if (this.schedule.date.month < 12) {
          this.schedule.date.month = this.schedule.date.month + 1
        } else {
          this.schedule.date.month = 1
          this.schedule.date.year = this.schedule.date.year + 1
        }
      } else if (direction === `prev`) {
        if (this.schedule.date.month > 1) {
          this.schedule.date.month = this.schedule.date.month - 1
        } else {
          this.schedule.date.month = 12
          this.schedule.date.year = this.schedule.date.year - 1
        }
      }

      this.getBookings(this.schedule.date.month, this.schedule.date.year)
    },

    getBookings(month, year) {
      this.schedule.loading = true

      fetch(`${process.env.VUE_APP_API_URL}?action=getMonthSchedule&year=${year}&month=${month}`)
        .then(response => response.json())
        .then(data => {
          this.bookings = data
          this.schedule.loading = false
        })
        .catch(error => {
          console.error(error)
          this.schedule.loading = false
        })
    },

    removeBooking(id) {
      if (confirm(`Remove this item?`)){
        fetch(`${process.env.VUE_APP_API_URL}?action=removeBooking&id=${id}`)
          .then(() => {
            this.getBookings(this.schedule.date.month, this.schedule.date.year)
          })
          .catch(error => console.error(error))
      }
    },

    toggleModal(id = 0, room = ``, date = ``, time_from = ``) {
      this.modal.booking.id = id
      this.modal.booking.room = room
      this.modal.booking.date = date
      this.modal.booking.time_from = time_from
      this.modal.active = !this.modal.active
    },

    scrollToToday() {
      this.schedule.date.month = parseInt(moment().format(`M`));
      this.schedule.date.year = parseInt(moment().format(`YYYY`));
      this.getBookings(this.schedule.date.month, this.schedule.date.year);
      this.$refs.schedule.scrollToToday();
    }

  },
  data: function () {
    return {
      rooms: [
        `medialab`,
        `lounge`,
        `office`,
        `workplatz`
      ],
      schedule: {
        loading: false,
        date: {
          month: parseInt(moment().utcOffset(2).format(`M`)),
          year: parseInt(moment().utcOffset(2).format(`YYYY`)),
        }
      },
      bookings: [],
      modal: {
        active: false,
        booking: {
          id: 0,
          room: ``,
          date: ``,
          time_from: ``,
        }
      }
    }
  },
  mounted: function () {
    this.getBookings(this.schedule.date.month, this.schedule.date.year)

    window.addEventListener('keyup', e => {
      if (e.key == `ArrowLeft` && !this.modal.active) {
        this.changeScheduleDate(`prev`)
      } else if (e.key == `ArrowRight` && !this.modal.active) {
        this.changeScheduleDate(`next`)
      } else if (e.key === `Escape` && this.modal.active) {
        this.toggleModal()
      }
    })
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background-color: #111;
  font-family: Tahoma, sans-serif;
  color: #fff;
}
</style>
